<template>
    <b-modal ref="profile_modal"
             size="lg"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=false
             :hide-header=true
             :hide-footer="true"
             class="modal-backdrop-transparent "
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>


        <ul class="app-list w-auto h-auto p-0 text-left">
            <li>
                <a href="/" class="app-list-item text-white border-0 m-0">
                    <div class="icon-stack">
                        <i class="base base-7 icon-stack-3x opacity-100 color-primary-500 "></i>
                        <i class="base base-7 icon-stack-2x opacity-100 color-primary-300 "></i>
                        <i class="fal fa-home icon-stack-1x opacity-100 color-white"></i>
                    </div>
                    <span class="app-list-name">
                         MAIN
                    </span>
                </a>
            </li>

            <li>
                <a target="_blank" href="/go_direct_service/orders" class="app-list-item text-white border-0 m-0">
                    <div class="icon-stack">
                        <i class="base base-7 icon-stack-3x opacity-100 color-success-500 "></i>
                        <i class="base base-7 icon-stack-2x opacity-100 color-success-300 "></i>
                        <i class="ni ni-envelope icon-stack-1x text-white"></i>
                    </div>
                    <span class="app-list-name">
                           GO_ORDERS
                    </span>
                </a>
            </li>
            <li>
                <a  target="_blank" href="/go_direct_service/preview" class="app-list-item text-white border-0 m-0">
                    <div class="icon-stack">
                        <i class="base base-7 icon-stack-3x opacity-100 color-success-500 "></i>
                        <i class="base base-7 icon-stack-2x opacity-100 color-success-300 "></i>
                        <i class="ni ni-envelope icon-stack-1x text-white"></i>
                    </div>
                    <span class="app-list-name">
                        GO_PREVIEW
                    </span>
                </a>
            </li>

            <li>
                <a  target="_blank" href="/go_direct_service/partners" class="app-list-item text-white border-0 m-0">
                    <div class="icon-stack">
                        <i class="base base-7 icon-stack-3x opacity-100 color-success-500 "></i>
                        <i class="base base-7 icon-stack-2x opacity-100 color-success-300 "></i>
                        <i class="ni ni-envelope icon-stack-1x text-white"></i>
                    </div>
                    <span class="app-list-name">
                        GO_PARTNERS
                    </span>
                </a>
            </li>

            <li>
                <a  target="_blank" href="/go_direct_service/analytics" class="app-list-item text-white border-0 m-0">
                    <div class="icon-stack">
                        <i class="base base-7 icon-stack-3x opacity-100 color-success-500 "></i>
                        <i class="base base-7 icon-stack-2x opacity-100 color-success-300 "></i>
                        <i class="ni ni-envelope icon-stack-1x text-white"></i>
                    </div>
                    <span class="app-list-name">
                        GO_ANALYTICS
                    </span>
                </a>
            </li>

        </ul>

    </b-modal>
</template>

<script>
export default {
    name: "menu_modal",
    props : {
        modal_position : {
            type : String,
            default : "left"
        },
    },

    created() {
        EventBus.$on('show_adv_menu',this.show_mod)
    },

    methods : {

        show_mod() {
            this.is_show_modal = true;
        },

        close_mod() {
            this.close();
        },

        close() {
            this.is_show_modal = false;
        },
    },
    data() {
        return {
            is_show_modal: false,
        }
    },
    computed : {
        dialog_class_draw() {
            return "modal-dialog modal-dialog-top modal-transparent";

        },
    }

}
</script>



<style scoped>

</style>
